<template>
    <!-- <div>
        <base-steps :steps="steps" />
        <button type="button" class="btn btn-outline-primary">Button</button>
        <ol class="ml-32 list-decimal">
            <li v-for="(item, index) in currentBpis" :key="index">
                {{ item.forms.entreprise_info.name + "     " }} ------------
                {{ "         " + item.id }}
            </li>
        </ol>
    </div> -->
    <h1>tmp</h1>
</template>

<script>
// import { mapGetters } from "vuex";
// import { db } from "../services/firebase.service";

export default {
    mounted() {
        // db.collection("bpis")
        //     // .where("validation", "==", true)
        //     .orderBy("ValidationDate", "desc")
        //     .get()
        //     .then(querySnapshot => {
        //         this.currentDoc =
        //             querySnapshot.docs[querySnapshot.docs.length - 1];
        //         const documents = querySnapshot.docs.map(doc => {
        //             return { forms: doc.data(), id: doc.id };
        //         });
        //         this.currentBpis = documents;
        //     });
    },
    data() {
        return {
            currentDoc: "",
            currentBpis: "",
            steps: [
                {
                    title: "tech",
                    isCompleted: true,
                    current: false
                },
                {
                    title: "tech",
                    isCompleted: false,
                    current: true
                },
                {
                    title: "tech",
                    isCompleted: false,
                    current: false
                }
            ]
        };
    },
    computed: {
        // ...mapGetters("forms", {
        //     s: "getSteps"
        // })
    }
};
</script>

<style scoped src="../assets/styles/bootstrap.min.css"></style>
